import { configureStore } from "@reduxjs/toolkit";

import enaeaReducer from "./enaeaSlice";

const store = configureStore({
  reducer: {
    enaea: enaeaReducer,
  },
});
export { store };
// 从 store 本身推断 `RootState` 和 `RootDispatch` 类型
export type RootState = ReturnType<typeof store.getState>;
// 推断类型
export type RootDispatch = typeof store.dispatch;
